export default "__VITE_ASSET__278afbd0__"